import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const SBoxWithPadding = styled(Box)(() => ({
    paddingTop: '10px',
    paddingBottom: '10px'
}));